export default __webpack_public_path__ + "static/media/chosen-ph.56bb76b6.webp";